import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {BdConfigPage} from "../page/bd-config/bd-config.page";


const bdModuleEntry: TestModuleDefinition = {
    key: 'bd',
    label: 'Dunning (bd)',
    components: [

        {
            key: 'BdConfigPage',
            component: BdConfigPage,
            selector: 'bd-config-page',
            type: 'PageComponent',
            label: 'bd config'
        },
    ]
}

export const BD_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: bdModuleEntry, multi: true}
];
